module.exports = __webpack_public_path__ + "img/question_text.b6a75710.png";